export default "__VITE_ASSET__DT_m4isy__"